import { ILevelsState } from "@edp-store/state/levels.state";
import { createSelector } from "@ngrx/store";
import { IAppState } from "../state/app.state";

const levelsSelector = (state: IAppState) => state.levels;

export const getUserLevel = createSelector(levelsSelector, (state: ILevelsState) => state.userLevel);
export const getHistory = createSelector(levelsSelector, (state: ILevelsState) => state.history);
export const getCelebrationScore = createSelector(levelsSelector, (state: ILevelsState) => state.celebration);
